import z from 'zod'
import { nullSafeBoolean, nullSafeOptionalString } from '../shared/schema'

export const schema = z.object({
  enabled: nullSafeBoolean(false),
  reason: nullSafeOptionalString(),
})

export const empty = Object.freeze(
  schema.parse({
    enabled: false,
    reason: undefined,
  })
)

export type FirestoreSettingsKillSwitch = z.infer<typeof schema>
